export default class MapAdapter {
  constructor({ container, center, zoom = 6, ...rest }) {
    this._container = container;
    this._center = center;
    this._zoom = zoom;
    this._configOptions = rest;
    
    
    this._styles = [
      {
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      }
    ];

    this._map = null;
  }

  init() {
    this._map = new google.maps.Map(this._container, {
      zoom: this._zoom,
      center: this._center,
      styles: this._styles,
      fullscreenControl: false,
      streetViewControl: false, // Disable Street View
      mapTypeControl: false,
      ...this._configOptions,
    });
  }

  setCenter(obj) {
    this._map.panTo(obj);
  }

  getInstance() {
    return this._map;
  }
}
